import React from "react";
import { Navigate } from "react-router-dom";

function parseToken(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp * 1000 < Date.now()) return null;
    return payload;
  } catch {
    return null;
  }
}

const ProtectedRoute = ({ role, children }) => {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to={role === "admin" ? "/admin/login" : "/"} replace />;

  const payload = parseToken(token);
  if (!payload || payload.role !== role) {
    return <Navigate to={role === "admin" ? "/admin/login" : "/"} replace />;
  }

  return children;
};

export default ProtectedRoute;
